/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Icon, message} from 'antd'
// import {DateTimePicker} from "react-advance-jalaali-datepicker";
import Select from 'react-select'

import moment from 'moment'
import jMoment from 'moment-jalaali'
import {Link} from 'react-router-dom'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import ORDER_STATUS from '../BaseComponent/ORDERSTATUS'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {Pagination} from 'antd'
import CRM from '../BaseComponent/CRM'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import Page from '../Pagination/Pagination'
import Loader from '../loaders/loader'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import {editOrder} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'
const Option = Select.Option

class CreateDelivery extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      processCategories: [],
      processCategoryId: null,
      error: '',
      selectedDate: null,
      location: [],
      orderStatus: [],
      selectBoxText: '',
      providers: [],
      today: moment(),
      input_supplierName: '',
      selectedOption: [],
      families: [],
      selectedFamily: {
        commentLabel: '',
        commentLabelMandatory: false,
        commentLabelVisibility: false,

        // dateTimeLabelMandatory: false,
        // dateTimeLabelVisibility: false,
        dateLabelVisibility: false,
        dateLabelMandatory: false,
        timeLabelVisibility: false,
        timeLabelMandatory: false,
        dateLabel: '',
        timeLabel: '',
        deliveryPackIdMandatory: false,
        deliveryPackIdVisibility: false,
        enabled: false,
        id: null,
        invoiceIdMandatory: false,
        invoiceIdVisibility: false,
        phoneLabel: '',
        phoneLabelMandatory: false,
        phoneLabelVisibility: false,
        providerMandatory: false,
        providerVisibility: false,
        selectiveItemLabel: '',
        selectiveItemLabelMandatory: false,
        selectiveItemLabelVisibility: false,
        sortOrder: 100,
        userLabelVisibility: false,
        userLabelMandatory: false,
        userLabel: '',
        textLabel: '',
        textLabelMandatory: false,
        textLabelVisibility: false,
        title: '',
        userCodeMandatory: false,
        userCodeVisibility: false
      },
      selectedFamilyId: null,
      initialTimeStamp: null,
      model: {
        providerId: '',
        locationId: '',
        visitorName: '',
        visitorPhone: '',
        statusId: '',
        description: '',
        deliveryPackId: '',
        invoiceId: '',
        userCode: '',
        hour: '',
        min: '',
        userId: ''
      },
      searchedCustomer: [],
      partSearchedCustomer: [],
      pageNumber: 1,
      current: 1,
      deliveryPacks: [],
      orderDate: null,
      orderDateTo: null,
      deliveryDate: null,
      deliveryDateTo: null,
      searchedCustomerByInvoice: [],
      partSearchedCustomerByInvoice: [],
      selectedUserText: '',
      operators: []
    }
  }

  componentDidMount() {
    if (localStorage.getItem('processObject')) {
      const processObject = JSON.parse(localStorage.getItem('processObject'))
      this.setState(
        {
          processCategoryId: processObject.processCategoryId,
          selectedFamilyId: processObject.selectedFamilyId,
          selectedFamily: processObject.selectedFamily
          // model: processObject.model,
          // selectedUserText: processObject.selectedUserText,
          // initialTimeStamp: processObject.initialTimeStamp
        },
        () => {
          if (this.state.processCategoryId) {
            this.getFamily(this.state.processCategoryId.id)
          }
          if (this.state.selectedFamily) {
            this.getDeliveryLocation(this.state.selectedFamily.id)
            this.getDeliveryStatus(this.state.selectedFamily.id)
          }
          if (this.state.selectedFamily.userLabelVisibility) {
            this.getUsers()
          }
          // if (this.state.model.deliveryPackId) {
          //     let selectedUserText = this.state.selectedUserText.split(' - ')
          //     this.searchDeliveryPacks(this.state.model.invoiceId, selectedUserText[0], selectedUserText[1]).then(() => {
          //         if (this.state.selectedUserText === ' - undefined') {
          //             this.setState({
          //                 selectedUserText: ''
          //             })
          //         }
          //     })
          // }
        }
      )
    }
    Promise.all([this.getProcessCategories()]).then(() => {})
  }

  handleChange = (providerId) => {
    let {model} = this.state
    model['providerId'] = providerId === null ? '' : providerId
    this.setState(
      {
        model
      },
      () => {
        const processObject = JSON.parse(localStorage.getItem('processObject'))
        processObject.model = this.state.model
        localStorage.setItem('processObject', JSON.stringify(processObject))
      }
    )
  }
  changeOperator = (userId) => {
    let {model} = this.state
    model['userId'] = userId === null ? '' : userId
    this.setState(
      {
        model
      },
      () => {
        const processObject = JSON.parse(localStorage.getItem('processObject'))
        processObject.model = this.state.model
        localStorage.setItem('processObject', JSON.stringify(processObject))
      }
    )
  }

  getProcessCategories = () => {
    return http
      .get(`process-category/list`, {})
      .then((res) => {
        if (res.data.error === null) {
          res.data.object.forEach((item) => {
            item.value = item.id
            item.label = item.title
          })
          this.setState({
            processCategories: res.data.object
          })
        }
      })
      .catch(() => {})
  }

  getFamily = (processCategoryId) => {
    return http
      .get(`process/report/operator`, {
        params: {
          processCategoryId,
          export: true
        }
      })
      .then((res) => {
        if (res.data.error === null) {
          let families = res.data.object.result
          families.forEach((item) => {
            item.value = item.id
            item.label = item.title
          })
          this.setState({
            families
          })
        } else {
          this.setState({
            selectedFamilyId: null,
            families: [],
            selectedFamilyId: null,
            location: [],
            orderStatus: [],
            selectedFamily: {
              commentLabel: '',
              commentLabelMandatory: false,
              commentLabelVisibility: false,
              dateLabel: '',
              timeLabel: '',
              dateLabelVisibility: false,
              dateLabelMandatory: false,
              timeLabelVisibility: false,
              timeLabelMandatory: false,
              deliveryPackIdMandatory: false,
              deliveryPackIdVisibility: false,
              enabled: false,
              id: null,
              invoiceIdMandatory: false,
              invoiceIdVisibility: false,
              phoneLabel: '',
              phoneLabelMandatory: false,
              phoneLabelVisibility: false,
              providerMandatory: false,
              providerVisibility: false,
              selectiveItemLabel: '',
              selectiveItemLabelMandatory: false,
              selectiveItemLabelVisibility: false,
              sortOrder: 100,
              userLabelVisibility: false,
              userLabelMandatory: false,
              userLabel: '',
              textLabel: '',
              textLabelMandatory: false,
              textLabelVisibility: false,
              title: '',
              userCodeMandatory: false,
              userCodeVisibility: false
            },
            model: {
              providerId: '',
              locationId: '',
              visitorName: '',
              visitorPhone: '',
              statusId: '',
              description: '',
              deliveryPackId: '',
              invoiceId: '',
              userCode: '',
              hour: '',
              min: '',
              userId: ''
            },
            initialTimeStamp: null
          })
        }
      })
      .catch((err) => {})
  }

  getDeliveryLocation = (familyStatusChangesId) => {
    return http
      .get(`deliveryStatus/location/report`, {
        params: {
          processId: familyStatusChangesId,
          export: true
        }
      })
      .then((response) => {
        if (response.data.error === null) {
          this.setState(
            {
              location: response.data.object.result
            },
            () => {
              if (this.state.location.length === 1) {
                let {model} = this.state
                model['locationId'] = this.state.location[0].id
                this.setState({
                  model
                })
              }
            }
          )
        } else {
          this.setState({
            location: []
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getDeliveryStatus = (familyStatusChangesId) => {
    return http
      .get(`deliveryStatus/status/report`, {
        params: {
          processId: familyStatusChangesId,
          export: true
        }
      })
      .then((response) => {
        if (response.data.error === null) {
          if (response.data.object.result.length > 0) {
            this.setState(
              {
                orderStatus: response.data.object.result.filter((item) => item.statusProcessLevelOut.id === 1)
              },
              () => {
                if (this.state.orderStatus.length === 1) {
                  let {model} = this.state
                  model['statusId'] = this.state.orderStatus[0].id
                  this.setState({
                    model
                  })
                }
              }
            )
          }
        } else {
          this.setState({
            orderStatus: []
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  changeFeilds = (e) => {
    let value = e.target.value
    let id = e.target.id
    let {model} = this.state
    model[id] = value
    this.setState(
      {
        model
      },
      () => {
        const processObject = JSON.parse(localStorage.getItem('processObject'))
        processObject.model = this.state.model
        localStorage.setItem('processObject', JSON.stringify(processObject))
      }
    )
  }

  submit() {
    let {
      providerId,
      min,
      hour,
      visitorName,
      statusId,
      locationId,
      visitorPhone,
      deliveryPackId,
      invoiceId,
      userCode,
      description,
      userId
    } = this.state.model
    let {initialTimeStamp, selectedFamilyId, selectedFamily} = this.state
    let formError = false
    let providerError = false
    let timeError = false
    let locError = false
    let mobileError = false
    let visitorError = false
    let statusError = false
    let cmError = false
    let hourError = false
    let minError = false
    let deliveryPackIdError = false
    let userCodeError = false
    let invoiceIdError = false
    let userError = false

    if (selectedFamilyId === null) {
      message.error('خانواده فرایند را انتخاب کنید')
    } else {
      if (selectedFamily.providerMandatory) {
        if (providerId === '') {
          formError = true
          providerError = true
          message.error('تامین کننده را وارد کنید')
        } else {
          if (!providerError) {
          }
        }
      }

      if (selectedFamily.userLabelMandatory) {
        if (userId === '') {
          formError = true
          userError = true
          message.error(selectedFamily.userLabel + ' را انتخاب کنید ')
        } else {
          if (!userError) {
          }
        }
      }

      if (selectedFamily.timeLabelMandatory) {
        if (hour == '' || min == '') {
          formError = true
          hourError = true
          minError = true
          message.error('ساعت ' + selectedFamily.timeLabel + ' را وارد کنید ')
        }
        if (hour >= 24 || hour < 0) {
          formError = true
          hourError = true
          message.error('ساعت ' + selectedFamily.timeLabel + ' باید بین 00 و 23 باشد ')
        }
        if (min >= 60 || min < 0) {
          formError = true
          minError = true
          message.error('دقیقه ' + selectedFamily.timeLabel + ' باید بین 00 و 59 باشد')
        } else {
          if (!hourError && !minError) {
            this.setState({
              error: ''
            })
          }
        }
      }
      if (selectedFamily.dateLabelMandatory) {
        let x = document.getElementById('initialTimeStamp').value
        if (x === null || x === '') {
          timeError = true
          formError = true
          message.error('' + selectedFamily.dateLabel + ' را انتخاب کنید ')
        } else {
          if (!timeError) {
          }
        }
      }
      if (selectedFamily.textLabelMandatory) {
        if (visitorName === '') {
          visitorError = true
          formError = true
          message.error(selectedFamily.textLabel + ' را وارد کنید ')
        } else if (visitorName.length > 256) {
          visitorError = true
          formError = true
          message.error('طول ' + selectedFamily.textLabel + ' باید کمتر از 256 باشد ')
        } else {
          if (!visitorError) {
          }
        }
      } else {
        if (visitorName.length > 256) {
          visitorError = true
          formError = true
          message.error('طول ' + selectedFamily.textLabel + ' باید کمتر از 256 باشد ')
        }
      }

      if (selectedFamily.selectiveItemLabelMandatory) {
        if (locationId == '') {
          formError = true
          locError = true
          message.error(selectedFamily.selectiveItemLabel + ' را مشخص کنید ')
        } else {
          if (!locError) {
            this.setState({
              error: ''
            })
          }
        }
      }
      if (selectedFamily.phoneLabelMandatory) {
        if (visitorPhone === '') {
          mobileError = true
          formError = true
          message.error(selectedFamily.phoneLabel + ' را وارد کنید ')
        } else if (visitorPhone.length > 256) {
          mobileError = true
          formError = true
          message.error('طول ' + selectedFamily.phoneLabel + ' باید کمتر از 256 باشد ')
        } else {
          if (!mobileError) {
          }
        }
      } else {
        if (visitorPhone.length > 256) {
          mobileError = true
          formError = true
          message.error('طول ' + selectedFamily.phoneLabel + ' باید کمتر از 256 باشد ')
        }
      }

      if (selectedFamily.commentLabelMandatory) {
        if (description === '') {
          formError = true
          cmError = true
          message.error(selectedFamily.commentLabel + ' را وارد کنید ')
        } else if (description.length > 1024) {
          formError = true
          cmError = true
          message.error('طول ' + selectedFamily.commentLabel + ' باید کمتر از 1024 باشد ')
        } else {
          if (!cmError) {
          }
        }
      } else {
        if (description.length > 1024) {
          formError = true
          cmError = true
          message.error('طول ' + selectedFamily.commentLabel + ' باید کمتر از 1024 باشد ')
        }
      }
      if (selectedFamily.deliveryPackIdMandatory) {
        if (deliveryPackId === '') {
          formError = true
          deliveryPackIdError = true
          message.error('شناسه پارت تحویل را وارد کنید')
        } else {
          if (!deliveryPackIdError) {
          }
        }
      }
      if (selectedFamily.invoiceIdMandatory) {
        if (invoiceId === '') {
          invoiceIdError = true
          formError = true
          message.error('شناسه فاکتور را وارد کنید')
        } else {
          if (!invoiceIdError) {
          }
        }
      }
      if (selectedFamily.userCodeMandatory) {
        if (userCode === '') {
          userCodeError = true
          formError = true
          message.error('کد مشتری را وارد کنید')
        } else {
          if (!userCodeError) {
          }
        }
      }
      if (statusId == '') {
        formError = true
        statusError = true
        message.error('وضعیت را مشخص کنید')
      } else {
        if (!statusError) {
          this.setState({
            error: ''
          })
        }
      }

      if (!selectedFamily.timeLabelMandatory) {
        if (hour !== '' && min === '') {
          formError = true
          hourError = true
          message.error('ساعت وارد شده معتبر نیست.مقدار دقیقه را وارد کنید')
        }
        if (min !== '' && hour === '') {
          formError = true
          hourError = true
          message.error('ساعت وارد شده معتبر نیست.مقدار ساعت را وارد کنید')
        }
      }

      if (hour !== '' && (hour >= 24 || hour < 0)) {
        formError = true
        hourError = true
        message.error('ساعت ' + selectedFamily.timeLabel + ' باید بین 00 و 23 باشد ')
      } else {
        if (!hourError) {
        }
      }
      if (min !== '' && (min >= 60 || min < 0)) {
        formError = true
        minError = true
        message.error('دقیقه ' + selectedFamily.timeLabel + ' باید بین 00 و 59 باشد')
      } else {
        if (!minError) {
        }
      }
      if (!formError) {
        let model = {
          providerId: selectedFamily.providerVisibility ? providerId : '',
          locationId: selectedFamily.selectiveItemLabelVisibility ? locationId : '',
          statusId,
          visitorName: selectedFamily.textLabelVisibility ? visitorName : '',
          visitorPhone: selectedFamily.phoneLabelVisibility ? visitorPhone : '',
          description: selectedFamily.commentLabelVisibility ? description : '',
          invoiceId: selectedFamily.invoiceIdVisibility ? invoiceId : '',
          deliveryPackId: selectedFamily.deliveryPackIdVisibility ? deliveryPackId : '',
          userCode: selectedFamily.userCodeVisibility ? userCode : '',
          initialDate: this.calcDate(selectedFamily.dateLabelVisibility),
          initialTime: this.calcTime(selectedFamily.timeLabelVisibility),
          userId: selectedFamily.userLabelVisibility ? userId.personId : ''
        }
        this.setState({
          loading: true
        })

        http
          .post(`deliveryStatus/create`, model, {})
          .then((response) => {
            this.setState({
              loading: false
            })
            if (response.data.error === null) {
              message.success('با موفقیت ثبت شد.لطفا صبر کنید')
              setInterval(() => {
                window.location.assign('/deliveryStatus/report')
              }, 2000)
            } else {
              message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
            }
          })
          .catch((error) => {
            this.setState({
              loading: false
            })
          })
      }
    }
  }

  calcDate = (dateLabelVisibility) => {
    if (!dateLabelVisibility) {
      return null
    } else {
      let date = document.getElementById('initialTimeStamp').value
      if (dateLabelVisibility && date !== '') {
        let x = this.validateDate(date, '00:00')
        return x
      } else if (dateLabelVisibility && date === '') {
        return null
      }
    }
  }

  calcTime = (timeLabelVisibility) => {
    if (!timeLabelVisibility) {
      return null
    } else {
      let {hour, min} = this.state.model
      if (timeLabelVisibility && hour !== '' && min !== '') {
        return this.validateHour()
      } else {
        return null
      }
    }
  }

  validateDate = (date, hour) => {
    return this.epochFrom(this.convertDigit(date + hour))
  }
  validateHour = () => {
    let currentDate = this.convertDigit(jMoment().format('jYYYY/jMM/jDD'))
    let {hour, min} = this.state.model
    return this.epochFrom(this.convertDigit(currentDate + hour + ':' + min))
  }

  validateInitialTimeStamp = (model) => {
    let x = ''
    if (!model.dateTimeLabelMandatory) {
      let date = document.getElementById('initialTimeStamp').value
      if (model.dateTimeLabelVisibility) {
        let {min, hour} = this.state.model
        if (date === '') {
          x = ''
        } else {
          if (min === '' || hour === '') {
            x = this.epochFrom(this.convertDigit(date + '00:00'))
          } else {
            x = this.epochFrom(this.convertDigit(date + hour + ':' + min))
          }
        }
      }
    } else {
      let date = document.getElementById('initialTimeStamp').value
      let {min, hour} = this.state.model
      x = this.epochFrom(this.convertDigit(date + hour + ':' + min))
    }
    return x
  }

  epochFrom = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = (concatDayMount[1] + concatDayMount[2]).substr(0, 4)
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD HH:mm').format('YYYY/M/D HH:mm')
    let from = miladiDate
    let fromEpoch = moment.utc(from).valueOf()
    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }

  Date(props) {
    return <input className="form-control" {...props} />
  }

  handleDateChange = (initialTimeStamp) => {
    this.setState(
      {
        initialTimeStamp
      },
      () => {
        const processObject = JSON.parse(localStorage.getItem('processObject'))
        processObject.initialTimeStamp = this.state.initialTimeStamp
        localStorage.setItem('processObject', JSON.stringify(processObject))
      }
    )
  }

  submitData(e) {
    e.preventDefault()
  }

  changeSelect(value) {
    this.setState({
      input_supplierName: value
    })
  }

  changeFamily = (selectedFamily) => {
    if (selectedFamily === null) {
      this.setState(
        {
          selectedFamilyId: null,
          location: [],
          orderStatus: [],
          selectedFamily: {
            commentLabel: '',
            commentLabelMandatory: false,
            commentLabelVisibility: false,
            dateLabel: '',
            timeLabel: '',
            dateLabelVisibility: false,
            dateLabelMandatory: false,
            timeLabelVisibility: false,
            timeLabelMandatory: false,
            deliveryPackIdMandatory: false,
            deliveryPackIdVisibility: false,
            enabled: false,
            id: null,
            invoiceIdMandatory: false,
            invoiceIdVisibility: false,
            phoneLabel: '',
            phoneLabelMandatory: false,
            phoneLabelVisibility: false,
            providerMandatory: false,
            providerVisibility: false,
            selectiveItemLabel: '',
            selectiveItemLabelMandatory: false,
            selectiveItemLabelVisibility: false,
            sortOrder: 100,
            userLabelVisibility: false,
            userLabelMandatory: false,
            userLabel: '',
            textLabel: '',
            textLabelMandatory: false,
            textLabelVisibility: false,
            title: '',
            userCodeMandatory: false,
            userCodeVisibility: false
          },
          model: {
            providerId: '',
            locationId: '',
            visitorName: '',
            visitorPhone: '',
            statusId: '',
            description: '',
            deliveryPackId: '',
            invoiceId: '',
            userCode: '',
            hour: '',
            min: '',
            userId: ''
          },
          initialTimeStamp: null,
          selectedUserText: ''
        },
        () => {
          const processObject = JSON.parse(localStorage.getItem('processObject'))
          processObject.selectedFamilyId = this.state.selectedFamilyId
          processObject.selectedFamily = this.state.selectedFamily
          processObject.model = this.state.model
          processObject.selectedUserText = ''
          localStorage.setItem('processObject', JSON.stringify(processObject))
        }
      )
    } else {
      this.setState(
        {
          selectedFamilyId: selectedFamily.id,
          selectedFamily,
          model: {
            providerId: '',
            locationId: '',
            visitorName: '',
            visitorPhone: '',
            statusId: '',
            description: '',
            deliveryPackId: '',
            invoiceId: '',
            userCode: '',
            hour: '',
            min: '',
            userId: '',
            description: ''
          },
          initialTimeStamp: null,
          selectedUserText: ''
        },
        () => {
          const processObject = JSON.parse(localStorage.getItem('processObject'))
          processObject.selectedFamilyId = this.state.selectedFamilyId
          processObject.selectedFamily = this.state.selectedFamily
          processObject.model = this.state.model
          processObject.selectedUserText = ''
          localStorage.setItem('processObject', JSON.stringify(processObject))
          if (this.state.selectedFamily.selectiveItemLabelVisibility) {
            this.getDeliveryLocation(selectedFamily.id)
          }
          if (this.state.selectedFamily.userLabelVisibility) {
            this.getUsers()
          }
          this.getDeliveryStatus(selectedFamily.id)
        }
      )
    }
  }

  getUsers = () => {
    http
      .get(`user/manage/list/user`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].personId
            result[i]['label'] = '' + result[i].personId + ' - ' + result[i].name
          }

          this.setState({
            operators: response.data.object
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  changeProcessCategory = (processCategoryId) => {
    if (processCategoryId === null) {
      this.setState(
        {
          processCategoryId: null,
          selectedFamilyId: null,
          families: [],
          selectedFamilyId: null,
          location: [],
          orderStatus: [],
          selectedFamily: {
            commentLabel: '',
            commentLabelMandatory: false,
            commentLabelVisibility: false,
            dateLabel: '',
            timeLabel: '',
            dateLabelVisibility: false,
            dateLabelMandatory: false,
            timeLabelVisibility: false,
            timeLabelMandatory: false,
            deliveryPackIdMandatory: false,
            deliveryPackIdVisibility: false,
            enabled: false,
            id: null,
            invoiceIdMandatory: false,
            invoiceIdVisibility: false,
            phoneLabel: '',
            phoneLabelMandatory: false,
            phoneLabelVisibility: false,
            providerMandatory: false,
            providerVisibility: false,
            selectiveItemLabel: '',
            selectiveItemLabelMandatory: false,
            selectiveItemLabelVisibility: false,
            sortOrder: 100,
            userLabelVisibility: false,
            userLabelMandatory: false,
            userLabel: '',
            textLabel: '',
            textLabelMandatory: false,
            textLabelVisibility: false,
            title: '',
            userCodeMandatory: false,
            userCodeVisibility: false
          },
          model: {
            providerId: '',
            locationId: '',
            visitorName: '',
            visitorPhone: '',
            statusId: '',
            description: '',
            deliveryPackId: '',
            invoiceId: '',
            userCode: '',
            hour: '',
            min: '',
            userId: ''
          },
          initialTimeStamp: null
        },
        () => {
          localStorage.setItem(
            'processObject',
            JSON.stringify({
              processCategoryId: this.state.processCategoryId,
              selectedFamilyId: this.state.selectedFamilyId,
              selectedFamily: this.state.selectedFamily,
              model: this.state.model,
              initialTimeStamp: this.state.initialTimeStamp
            })
          )
        }
      )
    } else {
      this.setState(
        {
          processCategoryId,
          selectedFamily: {
            commentLabel: '',
            commentLabelMandatory: false,
            commentLabelVisibility: false,
            dateLabel: '',
            timeLabel: '',
            dateLabelVisibility: false,
            dateLabelMandatory: false,
            timeLabelVisibility: false,
            timeLabelMandatory: false,
            deliveryPackIdMandatory: false,
            deliveryPackIdVisibility: false,
            enabled: false,
            id: null,
            invoiceIdMandatory: false,
            invoiceIdVisibility: false,
            phoneLabel: '',
            phoneLabelMandatory: false,
            phoneLabelVisibility: false,
            providerMandatory: false,
            providerVisibility: false,
            selectiveItemLabel: '',
            selectiveItemLabelMandatory: false,
            selectiveItemLabelVisibility: false,
            sortOrder: 100,
            userLabelVisibility: false,
            userLabelMandatory: false,
            userLabel: '',
            textLabel: '',
            textLabelMandatory: false,
            textLabelVisibility: false,
            title: '',
            userCodeMandatory: false,
            userCodeVisibility: false
          }
        },
        () => {
          localStorage.setItem(
            'processObject',
            JSON.stringify({
              processCategoryId: this.state.processCategoryId,
              selectedFamilyId: this.state.selectedFamilyId,
              selectedFamily: this.state.selectedFamily,
              model: this.state.model,
              initialTimeStamp: this.state.initialTimeStamp
            })
          )
          this.getFamily(processCategoryId.id)
        }
      )
    }
  }

  searchUser = () => {
    var CustomerCode = document.getElementById('CustomerCode').value
    var CustomerMobile = document.getElementById('CustomerMobile').value
    var nationalId = document.getElementById('nationalId').value
    var CustomerFirstName = document.getElementById('CustomerFirstName').value
    var CustomerLastName = document.getElementById('CustomerLastName').value
    if (
      nationalId == '' &&
      CustomerCode == '' &&
      CustomerMobile == '' &&
      CustomerFirstName == '' &&
      CustomerLastName == ''
    ) {
      message.error('حداقل یک فیلد وارد شود')
    } else {
      http
        .get(
          `${
            CRM.CRM_CONTACT_SEARCH_BY_CUSTOMER_INFO
          }?nationalId=${nationalId}&customerCode=${CustomerCode}&mobile=${CustomerMobile}&firstname=${CustomerFirstName}&lastname=${CustomerLastName}&export=true`,
          {}
        )
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null) {
            let result = response.data.object.result
            for (let i = 0; i < result.length; i++) {
              result[i]['isChecked'] = false
            }

            this.setState({
              selectedRadio: '',
              searchedCustomer: response.data.object.result,
              partSearchedCustomer: response.data.object.result.slice(0, 10),
              lengthSearchByCode: response.data.object.countAll,
              showTable: true
            })
          } else {
            this.setState({
              searchedCustomer: [],
              partSearchedCustomer: [],
              showTable: false
            })
          }
        })
    }
  }

  onChangePage(pageNumber) {
    // alert(pageNumber)
    this.setState({
      current: pageNumber,
      partSearchedCustomer: this.state.searchedCustomer.slice((pageNumber - 1) * 10, pageNumber * 10)
    })
  }

  selectUser = (customer) => {
    let {model} = this.state
    let id = 'userCode'
    model[id] = customer.code
    this.setState(
      {
        model,
        selectedUserText: customer.code + ' - ' + customer.firstName + ' ' + customer.lastName
      },
      () => {
        const processObject = JSON.parse(localStorage.getItem('processObject'))
        processObject.model = this.state.model
        processObject.selectedUserText = customer.code + ' - ' + customer.firstName + ' ' + customer.lastName
        localStorage.setItem('processObject', JSON.stringify(processObject))
        this.setState({
          userModal: false
        })
      }
    )
  }

  deleteUserCode = () => {
    let {model} = this.state
    let id = 'userCode'
    model[id] = ''
    this.setState(
      {
        model,
        selectedUserText: ''
      },
      () => {
        const processObject = JSON.parse(localStorage.getItem('processObject'))
        processObject.model = this.state.model
        processObject.selectedUserText = ''
        localStorage.setItem('processObject', JSON.stringify(processObject))
      }
    )
  }
  deleteInvoiceId = () => {
    let {model} = this.state
    model['invoiceId'] = ''
    model['deliveryPackId'] = ''
    this.setState(
      {
        model,
        deliveryPacks: []
      },
      () => {
        const processObject = JSON.parse(localStorage.getItem('processObject'))
        processObject.model = this.state.model
        localStorage.setItem('processObject', JSON.stringify(processObject))
      }
    )
  }

  epochFromModal = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochToModal = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  searchInvoice = () => {
    var input_CustomerCode = document.getElementById('customerCodeByInvoice').value.trim()
    var input_CustomerInvoiceId = document.getElementById('input_CustomerInvoiceId').value.trim()
    var input_CustomerInvoiceNum = document.getElementById('invoiceNum').value.trim()
    var registerDate = this.convertDigit(document.getElementById('registerDate').value)
    var registerDateTo = this.convertDigit(document.getElementById('registerDateTo').value)
    var deliveryDate = this.convertDigit(document.getElementById('deliveryDate').value)
    var deliveryDateTo = this.convertDigit(document.getElementById('deliveryDateTo').value)
    if (input_CustomerInvoiceId == '' && input_CustomerInvoiceNum == '' && input_CustomerCode == '') {
      message.error('حداقل فیلتر شناسه فاکتور یا شماره فاکتور یا کد مشتری وارد شود')
    } else {
      this.setState({
        loading: true
      })
      http
        .get(
          `${CRM.CRM_CONTACT_SEARCH_BY_CUSTOMER_INVOICE}?deliveryDateMin=${
            deliveryDate == '' ? '' : this.epochFromModal(deliveryDate)
          }&deliveryDateMax=${deliveryDateTo == '' ? '' : this.epochToModal(deliveryDateTo)}&registerDateMin=${
            registerDate == '' ? '' : this.epochFromModal(registerDate)
          }&registerDateMax=${
            registerDateTo == '' ? '' : this.epochToModal(registerDateTo)
          }&customerCode=${input_CustomerCode}&invoiceId=${input_CustomerInvoiceId}&invoiceNum=${input_CustomerInvoiceNum}&export=true&sortBy=regDate_desc`,
          {}
        )
        .then((response) => {
          // alert(JSON.stringify(response.data))

          this.setState({
            loading: false
          })
          if (response.data.error == null) {
            this.setState({
              selectedRadio: '',
              searchedCustomerByInvoice: response.data.object.result,
              partSearchedCustomerByInvoice: response.data.object.result.slice(0, 10),
              length: response.data.object.countAll,
              showTableByInvoice: true,
              current: 1,
              pageSize: 10
            })
          } else {
            this.setState({
              searchedCustomerByInvoice: [],
              partSearchedCustomerByInvoice: [],
              showTableByInvoice: false
            })
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
    }
  }

  searchDeliveryPacks = (invoiceId, code, buyer) => {
    let {selectedFamily} = this.state
    if (selectedFamily.deliveryPackIdVisibility) {
      this.setState({
        loading: true
      })
      return http
        .get(`delivery-packs/list`, {
          params: {
            invoiceId
          }
        })
        .then((res) => {
          this.setState({
            loading: false,
            invoiceModal: false
          })
          if (res.data.error === null) {
            this.setState(
              {
                deliveryPacks: res.data.object
              },
              () => {
                if (this.state.deliveryPacks.length === 1) {
                  let {model} = this.state
                  model['deliveryPackId'] = this.state.deliveryPacks[0].deliveryPackId
                  model['invoiceId'] = invoiceId
                  model['userCode'] = code

                  this.setState(
                    {
                      model,
                      selectedUserText: code + ' - ' + buyer
                    },
                    () => {
                      const processObject = JSON.parse(localStorage.getItem('processObject'))
                      processObject.model = this.state.model
                      processObject.selectedUserText = code + ' - ' + buyer
                      localStorage.setItem('processObject', JSON.stringify(processObject))
                    }
                  )
                } else {
                  let {model} = this.state
                  model['deliveryPackId'] = ''
                  model['invoiceId'] = invoiceId
                  model['userCode'] = code
                  this.setState(
                    {
                      model,
                      invoiceModal: false,
                      selectedUserText: code + ' - ' + buyer
                    },
                    () => {
                      const processObject = JSON.parse(localStorage.getItem('processObject'))
                      processObject.model = this.state.model
                      processObject.selectedUserText = code + ' - ' + buyer
                      localStorage.setItem('processObject', JSON.stringify(processObject))
                    }
                  )
                }
              }
            )
          } else {
            message.error(res.data.description)
          }
        })
        .catch((err) => {
          this.setState({
            loading: false
          })
        })
    } else {
      let {model} = this.state
      model['invoiceId'] = invoiceId
      model['userCode'] = code
      this.setState(
        {
          model,
          invoiceModal: false,
          selectedUserText: code + ' - ' + buyer
        },
        () => {
          const processObject = JSON.parse(localStorage.getItem('processObject'))
          processObject.model = this.state.model
          processObject.selectedUserText = code + ' - ' + buyer
          localStorage.setItem('processObject', JSON.stringify(processObject))
        }
      )
    }
  }

  handleOrderDate = (date) => {
    this.setState({orderDate: date})
  }

  handleOrderDateTo = (date) => {
    this.setState({orderDateTo: date})
  }

  handleDeliveryDate = (date) => {
    this.setState({deliveryDate: date})
  }

  handleDeliveryDateTo = (date) => {
    this.setState({deliveryDateTo: date})
  }

  orderDateEl(props) {
    return <input className="form-control" {...props} />
  }

  orderDateElTo(props) {
    return <input className="form-control" {...props} />
  }

  deliveryDateEl(props) {
    return <input className="form-control" {...props} />
  }

  deliveryDateElTo(props) {
    return <input className="form-control" {...props} />
  }

  onChangePageByInvoice(pageNumber) {
    // alert(pageNumber)
    this.setState({
      current: pageNumber,
      partSearchedCustomerByInvoice: this.state.searchedCustomerByInvoice.slice((pageNumber - 1) * 10, pageNumber * 10)
    })
  }

  goToMin = (e) => {
    // if (e.key !== 'Backspace') {
    //     if (document.getElementById('hour').focus) {
    //         let hour = document.getElementById('hour').value
    //         if (this.validationHour(hour)) {
    //             document.getElementById('min').focus()
    //         }
    //     }
    // }
  }

  validationHour = (x) => {
    switch (x) {
      case '00':
        return true
      case '01':
        return true
      case '02':
        return true
      case '03':
        return true
      case '04':
        return true
      case '05':
        return true
      case '06':
        return true
      case '07':
        return true
      case '08':
        return true
      case '09':
        return true
      case '10':
        return true
      case '11':
        return true
      case '12':
        return true
      case '13':
        return true
      case '14':
        return true
      case '15':
        return true
      case '16':
        return true
      case '17':
        return true
      case '18':
        return true
      case '19':
        return true
      case '20':
        return true
      case '21':
        return true
      case '22':
        return true
      case '23':
        return true
      default:
        return false
    }
  }
  removeDate = () => {
    this.setState(
      {
        initialTimeStamp: null
      },
      () => {
        const processObject = JSON.parse(localStorage.getItem('processObject'))
        processObject.initialTimeStamp = this.state.initialTimeStamp
        localStorage.setItem('processObject', JSON.stringify(processObject))
      }
    )
  }

  render() {
    const {selectedDate, selectedOption, selectedFamily, model, initialTimeStamp} = this.state

    return (
      <div className="rtl printA4Page">
        {!this.state.invoiceModal && <Loader show={this.state.loading} />}
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>مدیریت فرایندها</li>
            <li>افزودن</li>
          </ul>

          <form className={'verticalForm w-75'} onSubmit={this.submitData.bind(this)}>
            <div className="headerVertical">
              <p>افزودن فرایند</p>
            </div>
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-12">
                  <div className="formComponent selectComponent">
                    <label>
                      دسته فرایند <span className="requireFiled">*</span>
                    </label>
                    <Select
                      value={this.state.processCategoryId}
                      onChange={this.changeProcessCategory}
                      options={this.state.processCategories}
                      isMulti={false}
                      isClearable={true}
                      placeholder={''}
                      id="providerId"
                      name="providerId"
                      tabIndex="1"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="formComponent selectComponent">
                    <label>
                      خانواده فرایند <span className="requireFiled">*</span>
                    </label>
                    <Select
                      value={this.state.selectedFamily}
                      onChange={this.changeFamily}
                      options={this.state.families}
                      isMulti={false}
                      isClearable={true}
                      placeholder={''}
                      id="providerId"
                      name="providerId"
                      tabIndex="1"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                {selectedFamily.id !== null && (
                  <div className="col-12 col-sm-6">
                    <div className="formComponent">
                      <label>
                        وضعیت <span className="requireFiled">*</span>
                      </label>
                      <select
                        tabIndex="8"
                        className={'form-control'}
                        name="statusId"
                        onChange={this.changeFeilds}
                        id="statusId"
                      >
                        <option value="">-------</option>
                        {this.state.orderStatus.map((orderStatus, index) => (
                          <option
                            key={index}
                            selected={+this.state.model.statusId === +orderStatus.id ? true : false}
                            value={orderStatus.id}
                          >
                            {orderStatus.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                {selectedFamily.providerVisibility && (
                  <div className="col-xs-12 col-sm-6">
                    <div className="formComponent selectComponent">
                      <AutoComplete
                        label="تامین کننده"
                        api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                        textField="title"
                        valueField="providerId"
                        id="provider"
                        required={selectedFamily.providerMandatory ? true : false}
                        value={model.providerId}
                        setValue={this.handleChange}
                      />
                      {/* <label>تامین کننده
                                        {selectedFamily.providerMandatory && <span className='requireFiled'>*</span>}
                                    </label>
                                    <Select
                                        value={model.providerId}
                                        onChange={this.handleChange}
                                        options={this.state.providers}
                                        isMulti={false}
                                        isClearable={true}
                                        placeholder={''}
                                        id="providerId"
                                        name="providerId"
                                        tabIndex='1'
                                    /> */}
                    </div>
                  </div>
                )}
                {selectedFamily.userLabelVisibility && (
                  <div className="col-xs-12 col-sm-6">
                    <div className="formComponent selectComponent">
                      <label>
                        <span>{selectedFamily.userLabel}</span>
                        {selectedFamily.userLabelMandatory && <span className="requireFiled">*</span>}
                      </label>
                      <Select
                        value={model.userId}
                        onChange={this.changeOperator}
                        options={this.state.operators}
                        isMulti={false}
                        isClearable={true}
                        placeholder={''}
                        id="providerId"
                        name="providerId"
                        tabIndex="1"
                      />
                    </div>
                  </div>
                )}
                {selectedFamily.dateLabelVisibility && (
                  <div className="col-xs-12 col-sm-6">
                    <div className="formComponent position-relative">
                      <label>
                        {'تاریخ ' + selectedFamily.dateLabel}
                        {selectedFamily.dateLabelMandatory && <span className="requireFiled">*</span>}
                      </label>
                      <span
                        style={{
                          cursor: 'pointer',
                          position: 'absolute',
                          left: '15px',
                          bottom: '20px'
                        }}
                        onClick={() => this.removeDate()}
                      >
                        <img width="20" height="20" src={require('../../image/close.svg')} />
                      </span>
                      <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                        <DatePicker
                          okLabel="تأیید"
                          autoOk={true}
                          leftArrowIcon={<Icon type="left" />}
                          rightArrowIcon={<Icon type="right" />}
                          cancelLabel="لغو"
                          labelFunc={(initialTimeStamp) =>
                            initialTimeStamp == null ? '' : initialTimeStamp.format('jYYYY/jMM/jDD')
                          }
                          value={this.state.initialTimeStamp}
                          id="initialTimeStamp"
                          ref={(node) => (this.planDate = node)}
                          onChange={this.handleDateChange}
                          TextFieldComponent={this.Date}
                          tabIndex="2"
                          readOnly
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                )}
                {selectedFamily.timeLabelVisibility && (
                  <div className="col-12 col-sm-6">
                    <div className="formComponent">
                      <label>
                        {'ساعت ' + selectedFamily.timeLabel}
                        {selectedFamily.timeLabelMandatory && <span className="requireFiled">*</span>}
                      </label>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'flex-start'
                        }}
                      >
                        <input
                          tabIndex="4"
                          maxLength={2}
                          id="min"
                          name="min"
                          defaultValue={this.state.model.min}
                          onChange={this.changeFeilds}
                          placeholder="دقیقه"
                          className="form-control"
                          type="text"
                          style={{
                            width: '60px',
                            textAlign: 'center',
                            fontSize: '1em'
                          }}
                        />
                        <p style={{marginRight: '20px', fontSize: '2em'}}>:</p>
                        <input
                          tabIndex="3"
                          defaultValue={this.state.model.hour}
                          onKeyUp={(e) => this.goToMin(e)}
                          maxLength={2}
                          onChange={this.changeFeilds}
                          placeholder="ساعت"
                          id="hour"
                          className="form-control"
                          type="text"
                          style={{
                            width: '60px',
                            textAlign: 'center',
                            fontSize: '1em',
                            marginRight: '20px'
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {selectedFamily.textLabelVisibility && (
                  <div className="col-12 col-sm-6">
                    <div className="formComponent">
                      <label>
                        {selectedFamily.textLabel}
                        {selectedFamily.textLabelMandatory && <span className="requireFiled">*</span>}
                      </label>
                      <input
                        tabIndex="6"
                        type={'text'}
                        defaultValue={this.state.model.visitorName}
                        className={'form-control'}
                        onChange={this.changeFeilds}
                        name="visitorName"
                        id="visitorName"
                      />
                    </div>
                  </div>
                )}
                {selectedFamily.selectiveItemLabelVisibility && (
                  <div className="col-12 col-sm-6">
                    <div className="formComponent">
                      <label>
                        {selectedFamily.selectiveItemLabel}
                        {selectedFamily.selectiveItemLabelMandatory && <span className="requireFiled">*</span>}
                      </label>
                      <select
                        tabIndex="5"
                        className="form-control"
                        id="locationId"
                        onChange={this.changeFeilds}
                        name="locationId"
                      >
                        <option value={''}>-------</option>

                        {this.state.location.map((loc, index) => (
                          <option
                            key={index}
                            selected={+this.state.model.locationId === +loc.id ? true : false}
                            value={loc.id}
                          >
                            {loc.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
                {selectedFamily.phoneLabelVisibility && (
                  <div className="col-12 col-sm-6">
                    <div className="formComponent">
                      <label>
                        {selectedFamily.phoneLabel}
                        {selectedFamily.phoneLabelMandatory && <span className="requireFiled">*</span>}
                      </label>
                      <input
                        tabIndex="7"
                        type={'text'}
                        defaultValue={this.state.model.visitorPhone}
                        onChange={this.changeFeilds}
                        className={'form-control'}
                        id="visitorPhone"
                        name="visitorPhone"
                      />
                    </div>
                  </div>
                )}
                {selectedFamily.userCodeVisibility && (
                  <div className="col-12 col-sm-6">
                    <div className="formComponent">
                      <label>
                        کد مشتری
                        {selectedFamily.userCodeMandatory && <span className="requireFiled">*</span>}
                        <span
                          onClick={() => this.setState({userModal: true})}
                          style={{cursor: 'pointer'}}
                          className="mx-2 text-white font-weight-bold bg-info rounded p-1"
                        >
                          جستجوی مشتری
                        </span>
                        {this.state.selectedUserText !== '' && (
                          <span
                            style={{cursor: 'pointer'}}
                            className="mx-2 text-white font-weight-bold bg-danger rounded p-1"
                            onClick={this.deleteUserCode}
                          >
                            {' ' + 'حذف مشتری' + '  '}
                          </span>
                        )}
                      </label>
                      <input
                        disabled
                        tabIndex="7"
                        type={'text'}
                        value={this.state.selectedUserText}
                        onChange={this.changeFeilds}
                        className={'form-control'}
                        id="userCode"
                        name="userCode"
                      />
                    </div>
                  </div>
                )}
                {selectedFamily.invoiceIdVisibility && (
                  <div className="col-12 col-sm-6">
                    <div className="formComponent">
                      <label>
                        شناسه فاکتور
                        {selectedFamily.invoiceIdMandatory && <span className="requireFiled">*</span>}
                        <span
                          onClick={() => this.setState({invoiceModal: true})}
                          style={{cursor: 'pointer'}}
                          className="mx-2 text-white font-weight-bold bg-info rounded p-1"
                        >
                          جستجوی فاکتور
                        </span>
                        {this.state.model.invoiceId !== '' && (
                          <span
                            style={{cursor: 'pointer'}}
                            className="mx-2 text-white font-weight-bold bg-danger rounded p-1"
                            onClick={this.deleteInvoiceId}
                          >
                            {' ' + 'حذف شناسه فاکتور' + '  '}
                          </span>
                        )}
                      </label>
                      <input
                        disabled
                        tabIndex="7"
                        type={'hidden'}
                        value={this.state.model.invoiceId}
                        onChange={this.changeFeilds}
                        className={'form-control'}
                        id="invoiceId"
                        name="invoiceId"
                      />
                      <p>
                        <a
                          target="_blank"
                          href={editOrder({
                            invoiceId: this.state.model.invoiceId
                          })}
                          className="font-weigth-bold"
                        >
                          {this.state.model.invoiceId}
                        </a>
                      </p>
                    </div>
                  </div>
                )}
                {selectedFamily.deliveryPackIdVisibility && (
                  <div className="col-12 col-sm-6">
                    <div className="formComponent">
                      <label>
                        شناسه پارت تحویل
                        {selectedFamily.deliveryPackIdMandatory && <span className="requireFiled">*</span>}
                      </label>
                      <select
                        onChange={this.changeFeilds}
                        name="deliveryPackId"
                        className={'form-control'}
                        id="deliveryPackId"
                      >
                        <option value="">------</option>
                        {this.state.deliveryPacks.map((item, index) => (
                          <option
                            selected={this.state.model.deliveryPackId === item.deliveryPackId ? true : false}
                            value={item.deliveryPackId}
                          >
                            {' شناسه پارت تحویل :  ' +
                              item.deliveryPackId +
                              ' - ' +
                              jMoment(item.planDate).format('jYYYY/jM/jD') +
                              ' - ' +
                              ' در بازه  ' +
                              item.planTimeFrom.substr(0, 5) +
                              ' تا ' +
                              item.planTimeTo.substr(0, 5)}
                          </option>
                        ))}
                      </select>
                      {/* <input tabIndex='7' type={'text'}  className={'form-control'} id='deliveryPackId'
                                               name='deliveryPackId'/> */}
                    </div>
                  </div>
                )}

                {selectedFamily.commentLabelVisibility && (
                  <div className="col-sm-12">
                    <div className="formComponent">
                      <label>
                        {selectedFamily.commentLabel}
                        {selectedFamily.commentLabelMandatory && <span className="requireFiled">*</span>}
                      </label>
                      <textarea
                        defaultValue={this.state.model.description}
                        tabIndex="9"
                        onChange={this.changeFeilds}
                        className={'form-control'}
                        style={{minHeight: '200px'}}
                        name="description"
                        id="description"
                      />
                    </div>
                  </div>
                )}
                {selectedFamily.id !== null && (
                  <div className="col-sm-12">
                    <div className="formComponent">
                      <button className={'btn btn-info btn-block'} onClick={this.submit.bind(this)}>
                        افزودن
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
          <Modal isOpen={this.state.userModal} toggle={() => console.log('')} size="lg">
            <ModalHeader toggle={() => console.log('')}>جست و جوی مشتری</ModalHeader>

            <ModalBody>
              <div className="modalForm searchProduct">
                <figure>
                  <label>کد مشتری : </label>
                  <input type="text" className="form-control" id="CustomerCode" />
                </figure>
                <figure>
                  <label>موبایل : </label>
                  <input type="text" className="form-control" id="CustomerMobile" />
                </figure>
                <figure>
                  <label>نام : </label>
                  <input type="text" className="form-control" id="CustomerFirstName" />
                </figure>
                <figure>
                  <label>نام خانوادگی : </label>
                  <input type="text" className="form-control" id="CustomerLastName" />
                </figure>
                <figure>
                  <label>کد ملی : </label>
                  <input type="text" className="form-control" id="nationalId" />
                </figure>
                <figure>
                  <label className="hiddenLabel">332</label>
                  <span onClick={this.searchUser} className="searchCustommer">
                    جست و جو
                  </span>
                </figure>
              </div>
              <div style={this.state.showTable ? {display: 'block'} : {display: 'none'}}>
                <table className="baseTable">
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>#</td>
                    <td>نام</td>
                    <td>نام خانوادگی</td>
                    <td>کد مشتری</td>
                    <td>موبایل</td>
                    <td>کد ملی</td>
                  </tr>
                  {this.state.partSearchedCustomer.map((customer, index) => (
                    <tr>
                      <td>{(this.state.pageNumber - 1) * 10 + index + 1}</td>
                      <td>
                        <button
                          className="btn btn-sm"
                          style={{color: '#000', fontWeight: '600'}}
                          onClick={() => this.selectUser(customer)}
                        >
                          انتخاب
                        </button>
                      </td>
                      <td>{customer.firstName}</td>
                      <td>{customer.lastName}</td>
                      <td>{customer.code}</td>
                      <td>{customer.phoneNumber}</td>
                      <td>{customer.nationalId}</td>
                    </tr>
                  ))}
                </table>
                <div className="paginationWrapp">
                  <Pagination
                    current={this.state.current}
                    onChange={this.onChangePage.bind(this)}
                    total={this.state.lengthSearchByCode}
                  />
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button className="cancelBtnModal" onClick={() => this.setState({userModal: false})}>
                لغو
              </button>
            </ModalFooter>
          </Modal>
        </div>
        <Modal isOpen={this.state.invoiceModal} toggle={() => console.log('')} size="lg">
          <ModalHeader toggle={() => console.log('')}>جست و جوی فاکتور</ModalHeader>
          <ModalBody>
            <Loader show={this.state.loading} />
            <div className="modalForm searchProduct">
              <figure>
                <label>شناسه فاکتور : </label>
                <input type="text" className="form-control" id="input_CustomerInvoiceId" />
              </figure>
              <figure>
                <label>شماره فاکتور : </label>
                <input type="text" className="form-control" id="invoiceNum" />
              </figure>

              <figure>
                <label>کد مشتری : </label>
                <input
                  type="text"
                  defaultValue={this.state.model.userCode}
                  className="form-control"
                  id="customerCodeByInvoice"
                />
              </figure>

              <figure>
                <label>تاریخ سفارش از : </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    okLabel="تأیید"
                    cancelLabel="لغو"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    labelFunc={(orderDate) => (orderDate == null ? '' : orderDate.format('jYYYY/jMM/jDD'))}
                    onChange={this.handleOrderDate}
                    TextFieldComponent={this.orderDateEl}
                    id="registerDate"
                    name="registerDate"
                    value={this.state.orderDate}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </figure>

              <figure>
                <label>تاریخ سفارش تا : </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    okLabel="تأیید"
                    cancelLabel="لغو"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    labelFunc={(orderDateTo) => (orderDateTo == null ? '' : orderDateTo.format('jYYYY/jMM/jDD'))}
                    onChange={this.handleOrderDateTo}
                    TextFieldComponent={this.orderDateElTo}
                    id="registerDateTo"
                    name="registerDateTo"
                    value={this.state.orderDateTo}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </figure>
              <figure>
                <label>تاریخ تحویل از : </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    okLabel="تأیید"
                    cancelLabel="لغو"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    labelFunc={(deliveryDate) => (deliveryDate == null ? '' : deliveryDate.format('jYYYY/jMM/jDD'))}
                    onChange={this.handleDeliveryDate}
                    TextFieldComponent={this.deliveryDateEl}
                    id="deliveryDate"
                    name="deliveryDate"
                    value={this.state.deliveryDate}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </figure>

              <figure>
                <label>تاریخ تحویل تا : </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    okLabel="تأیید"
                    cancelLabel="لغو"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    labelFunc={(deliveryDateTo) =>
                      deliveryDateTo == null ? '' : deliveryDateTo.format('jYYYY/jMM/jDD')
                    }
                    onChange={this.handleDeliveryDateTo}
                    TextFieldComponent={this.deliveryDateElTo}
                    id="deliveryDateTo"
                    name="deliveryDateTo"
                    value={this.state.deliveryDateTo}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </figure>

              {/* <figure>
                                    <label className='hiddenLabel'>332</label>
                                    <span onClick={()=>this.searchInvoice()}
                                        className='searchCustommer'
                                    >جست و جو</span>
                                </figure> */}
            </div>
            <div style={this.state.showTableByInvoice ? {display: 'block'} : {display: 'none'}}>
              <table className="baseTable">
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>#</td>
                  <td>نام</td>
                  <td>شناسه فاکتور</td>
                  <td>شماره فاکتور</td>
                  <td>کد مشتری</td>
                  <td>موبایل</td>
                  <td>تاریخ ثبت</td>
                  <td>تاریخ تحویل</td>
                </tr>
                {this.state.partSearchedCustomerByInvoice.map((customer, index) => (
                  <tr>
                    <td>{(this.state.pageNumber - 1) * 10 + index + 1}</td>
                    <td>
                      <button
                        className="btn btn-sm"
                        style={{color: '#000', fontWeight: '600'}}
                        onClick={() =>
                          this.searchDeliveryPacks(customer.invoiceId, customer.code, customer.buyerFullName)
                        }
                      >
                        انتخاب
                      </button>
                    </td>
                    <td>{customer.buyerFullName}</td>
                    <td>{customer.invoiceId}</td>
                    <td>{customer.invoiceNum}</td>
                    <td>{customer.code}</td>
                    <td>{customer.phoneNumber}</td>
                    <td>{customer.regDate !== null && jMoment(customer.regDate).format('jYYYY/jMM/jDD HH:mm')}</td>
                    <td>
                      {customer.deliveryDate == null
                        ? '-'
                        : jMoment(customer.deliveryDate).format('jYYYY/jMM/jDD HH:mm')}
                    </td>
                  </tr>
                ))}
              </table>
              <div className="paginationWrapp">
                <Pagination
                  current={this.state.current}
                  onChange={this.onChangePageByInvoice.bind(this)}
                  total={this.state.length}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={() => this.searchInvoice()}>
              جستجو
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({invoiceModal: false})}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default CreateDelivery
